
import React from 'react';
import { Link } from 'react-router-dom';
import { FaBrain, FaComments, FaHandsHelping, FaSwimmer, FaMusic, FaUsers, FaWhatsapp } from 'react-icons/fa';

import psicologia from '../assets/img/tratamientos/psicologia.jpg'
import temperley_bw from '../assets/img/TemperleyBW.jpg'
import temperley_frente from '../assets/img/Temperley_Frente.jpg'
import glew_frente from '../assets/img/Glew_Frente.jpg'

const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/FXqBCP_4gNcaEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};

const Tratamientos = () => {
  const tratamientos = [
    {
      id: 1,
      title: "Psicología",
      description: "Abordaje individual para mejorar aspectos emocionales, cognitivos y conductuales, adaptado a las necesidades específicas de cada niño o joven. Trabajamos en coordinación con familias y otros profesionales.",
      icon: <FaBrain />,
      image: psicologia
    },
    {
      id: 2,
      title: "Fonoaudiología",
      description: "Evaluación y tratamiento de alteraciones del lenguaje, comunicación y deglución. Implementamos sistemas aumentativos y alternativos de comunicación para quienes lo requieren, facilitando su interacción con el entorno.",
      icon: <FaComments />,
      image: psicologia
    },
    {
      id: 3,
      title: "Terapia Ocupacional",
      description: "Desarrollo de habilidades para la vida diaria, buscando la mayor independencia posible. Trabajamos aspectos motores, sensoriales y cognitivos mediante actividades terapéuticas estructuradas.",
      icon: <FaHandsHelping />,
      image: psicologia
    },
    {
      id: 4,
      title: "Hidroterapia",
      description: "Terapia en medio acuático que promueve la relajación muscular, mejora la movilidad articular y brinda estimulación sensorial. El agua como medio terapéutico facilita movimientos que en tierra resultan más difíciles.",
      icon: <FaSwimmer />,
      image: psicologia
    },
    {
      id: 5,
      title: "Musicoterapia",
      description: "Utilización de la música y sus elementos para facilitar la comunicación, el aprendizaje y la expresión emocional. Estimula el desarrollo cognitivo, social y emocional a través de experiencias musicales estructuradas.",
      icon: <FaMusic />,
      image: psicologia
    },
    {
      id: 6,
      title: "Terapia Grupal",
      description: "Espacios de interacción social donde se trabajan habilidades de comunicación, cooperación y resolución de conflictos. Proporciona un entorno seguro para practicar habilidades sociales y fortalecer vínculos.",
      icon: <FaUsers />,
      image: psicologia
    }
  ];

  return (
    <div className="container">
      <div className="sede-header">
        <h1>Tratamientos Individuales</h1>
        <p>En Mi Lugar ofrecemos una amplia gama de tratamientos individuales, diseñados específicamente para atender las necesidades particulares de cada niño y joven.</p>
      </div>

      <section>
        <p className="text-center" style={{ marginBottom: '40px' }}>
          Nuestro enfoque terapéutico se basa en una evaluación integral que permite diseñar un plan de tratamiento personalizado. 
          Todos nuestros tratamientos son implementados por profesionales especializados, en coordinación con las familias 
          y otros miembros del equipo interdisciplinario.
        </p>

        <div className="treatment-container">
          {tratamientos.map(tratamiento => (
            <div key={tratamiento.id} className="treatment-card">
              <div className="treatment-image">
                <img src={tratamiento.image} alt={tratamiento.title} />
              </div>
              <div className="treatment-content">
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <div style={{ color: 'var(--primary-color)', fontSize: '1.5rem' }}>
                    {tratamiento.icon}
                  </div>
                  <h3>{tratamiento.title}</h3>
                </div>
                <p>{tratamiento.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-section" style={{ margin: '60px 0', padding: '40px', borderRadius: '10px' }}>
        <div className="cta-content">
          <h2>¿Necesitas más información sobre nuestros tratamientos?</h2>
          <p>Nuestro equipo profesional está disponible para responder todas tus preguntas y orientarte sobre el tratamiento más adecuado para tu hijo.</p>
          <div className="cta-buttons">
            <Link to="/contacto" className="btn">Consultar ahora</Link>
            <a href="https://wa.me/5491165651675" className="btn btn-accent">
              <FaWhatsapp /> Contactar por WhatsApp
            </a>
          </div>
        </div>
      </section>

       {/* WhatsApp Float Button With Report*/}
      <a
        href="#"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion("https://wa.me/5491165651675");
        }}
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default Tratamientos;
